import Oct17Ahan1 from "../Assets/17Oct2026-Ahan-1.jpeg";
import Oct17Group from "../Assets/17Oct2026-Group.jpeg";
import Oct17Raja1 from "../Assets/17Oct2026-Raja-1.jpeg";
import Oct17Katy1 from "../Assets/17Oct2026-Katy-1.jpeg";
import Oct17Rohit1 from "../Assets/17Oct2026-Rohit-1.jpeg";
import Oct17Rohit2 from "../Assets/17Oct2026-Rohit-2.jpeg";
import SunriseAhan16Oct1 from "../Assets/Sunrise-Ahan-16OctAug26-1.jpeg";
import SunriseAhan16Oct2 from "../Assets/Sunrise-Ahan-16OctAug26-2.jpeg";
import SunriseAhan16Oct3 from "../Assets/Sunrise-Ahan-16OctAug26-3.jpeg";
import PPPChuckAngel from "../Assets/PPPTournamentAug2026-Chuck_Angel.jpeg";
import PPPChuckJim from "../Assets/PPPTournamentAug2026-Chuck_Jim.jpeg";
import PPPChuckKevin from "../Assets/PPPTournamentAug2026-Chuck_Kevin.jpeg";
import PPPChuckNancy from "../Assets/PPPTournamentAug2026-Chuck_Nancy.jpeg";
import PPPDKaty from "../Assets/PPPTournamentAug2026-D_Katy.jpeg";
import PPPDKevin from "../Assets/PPPTournamentAug2026-D_Kevin.jpeg";
import PPPGroup from "../Assets/PPPTournamentAug2026-Group.jpeg";
import PPPKatyAhan from "../Assets/PPPTournamentAug2026-Katy_Ahan.jpeg";
import PPPKevin from "../Assets/PPPTournamentAug2026-Kevin.jpeg";
import PPPSaiKevin from "../Assets/PPPTournamentAug2026-Sai_Kevin.jpeg";
import PPPTrophies from "../Assets/PPPTournamentAug2026-Trophies.jpeg";
import Aug01Srikar1 from "../Assets/01Aug2026-Srikar-1.jpeg";
import Aug01Ahan2 from "../Assets/01Aug2026-Ahan-2.jpeg";
import Aug01Group1 from "../Assets/01Aug2026-Group-1.jpeg";
import Aug01Angel1 from "../Assets/01Aug2026-Angel-1.jpeg";
import Aug01Sai1 from "../Assets/01Aug2026-Sai-1.jpeg";
import Aug01Ahan1 from "../Assets/01Aug2026-Ahan-1.jpeg";
import Jul22_1 from "../Assets/22July2026-1.jpeg";
import Jul22_2 from "../Assets/22July2026-2.jpeg";
import Jul22_3 from "../Assets/22July2026-3.jpeg";
import Jul22_4 from "../Assets/22July2026-4.jpeg";
import Jul22_5 from "../Assets/22July2026-5.jpeg";
import Jul22_6 from "../Assets/22July2026-6.jpeg";
import Jul18Srikar3 from "../Assets/18July2026-Srikar-3.jpeg";
import Jul18Srikar2 from "../Assets/18July2026-Srikar-2.jpeg";
import Jul18Sai1 from "../Assets/18July2026-Sai-1.jpeg";
import Jul18Srikar1 from "../Assets/18July2026-Srikar-1.jpeg";
import Jul18Angel1 from "../Assets/18July2026-Angel-1.jpeg";
import Jul18Group from "../Assets/18July2026-Group.jpeg";
import Sunrise10July1 from "../Assets/Sunrise-Sai-10July26-1.jpeg";
import Sunrise10July2 from "../Assets/Sunrise-Sai-10July26-2.jpeg";
import Sunrise10July3 from "../Assets/Sunrise-Sai-10July26-3.jpeg";
import Sunrise10July4 from "../Assets/Sunrise-Sai-10July26-4.jpeg";
import Sunrise10July5 from "../Assets/Sunrise-Sai-10July26-5.jpeg";
import Sunrise10July6 from "../Assets/Sunrise-Sai-10July26-6.jpeg";
import Sunrise10July7 from "../Assets/Sunrise-Sai-10July26-7.jpeg";
import Sunrise21Aug1 from "../Assets/Sunrise-Sai-21Aug26-1.jpeg";
import Sunrise21Aug2 from "../Assets/Sunrise-Sai-21Aug26-2.jpeg";
import Sunrise21Aug3 from "../Assets/Sunrise-Sai-21Aug26-3.jpeg";
import Sunrise21Aug4 from "../Assets/Sunrise-Sai-21Aug26-4.jpeg";
import Jun27Group from "../Assets/27June2026-Group-1.jpeg";
import Jun27Rohit from "../Assets/27June2026-Rohit-1.jpeg";
import Jun27Raja from "../Assets/27June2026-Raja-1.jpeg";
import Jun27Ahan1 from "../Assets/27June2026-Ahan-1.jpeg";
import Jun27Ahan2 from "../Assets/27June2026-Ahan-2.jpeg";
import Jun27Ahan3 from "../Assets/27June2026-Ahan-3.jpeg";
import May23_1 from "../Assets/23May-1.jpeg";
import May23_2 from "../Assets/23May-2.jpeg";
import May23_3 from "../Assets/23May-3.jpeg";
import May23_4 from "../Assets/23May-4.jpeg";
import May23_5 from "../Assets/23May-5.jpeg";
import May23Group from "../Assets/23May-Group.jpeg";
import tt2025_1 from "../Assets/TT-Summer-2025-1.jpg";
import SaiSreyas from "../Assets/Sai&Sreyas.jpg";
import SaiSrikar from "../Assets/Sai&Srikar.jpg";
import SaiWithKids2026 from "../Assets/Sai-With-Kids-Feb2026.jpeg";
import SaiSchoolTTClub from "../Assets/Sai-Schoolmates-TTClub.jpeg";
import SaiCoachingKidFeb2026 from "../Assets/SaiCoachingKidFeb2026.jpeg";
import WAHighSchoolTeam2026 from "../Assets/WA-HighSchoolTeam-2026.jpeg";
import SaiWithParkisonsPatients07Mar26 from "../Assets/SaiWithParkisonsPatients07Mar26.jpeg";
import SaiWithPP1 from "../Assets/SaiWithPP1-07Mar26.jpeg";
import SaiWithParkisonsPatients21Mar26 from "../Assets/SaiParkisonsPatients21Mar26.jpeg";
import GroupParkisonsPatients21Mar26 from "../Assets/GroupParkisonsPatients21Mar26.jpeg";
import GroupParkisonsPatients04Apr2026 from "../Assets/GroupParkisonsPatients04Apr2026.jpeg";
import WAStateParksinsons2025_2 from "../Assets/WA-State-Parksinsons-2025-2.jpeg";
import USNationals2026OutReach from "../Assets/USNationals2026OutReach.jpeg";
import WAStateParksinsons2025_3 from "../Assets/WA-State-Parksinsons-2025-3.jpeg";
import WAStateParksinsons2025_4 from "../Assets/WA-State-Parksinsons-2025-4.jpeg";
import WAStateParksinsons2025_5 from "../Assets/WA-State-Parksinsons-2025-5.jpeg";
import ParkinsonGroup2025_1 from "../Assets/ParkinsonGroup-1-2025.jpeg";
import ParkinsonAngel2025 from "../Assets/Parkinson-Angel-2025.jpeg";
import Apr25JimSai from "../Assets/25Apr2026-Jim-Sai.jpeg";
import Apr25Group from "../Assets/25Apr2026-Group.jpeg";
import Apr25Joe from "../Assets/25Apr2026-Joe.jpeg";
import Apr25KaiMingAhan3 from "../Assets/25Apr2026-KaiMing-Ahan-3.jpeg";
import Apr25KaiMingAhan2 from "../Assets/25Apr2026-KaiMing-Ahan-2.jpeg";
import Apr25KaiMingAhan1 from "../Assets/25Apr2026-KaiMing-Ahan-1.jpeg";
import Apr25JoeRaja from "../Assets/25Apr2026-Joe-Raja.jpeg";
import May09Ahan from "../Assets/09May-Ahan.jpeg";
import May09Angel from "../Assets/09May-Angel.jpeg";
import May09Group from "../Assets/09May-Group.jpeg";
import May09Raja from "../Assets/09May-Raja.jpeg";
import May09Group2 from "../Assets/09May-Group-2.jpeg";
import May09Ahan2 from "../Assets/09May-Ahan-2.jpeg";
import Jun06Group from "../Assets/06June-Group.jpeg";
import Jun06_1 from "../Assets/06June-1.jpeg";
import Jun06_2 from "../Assets/06June-2.jpeg";
import Jun06_3 from "../Assets/06June-3.jpeg";
import Jun06_4 from "../Assets/06June-4.jpeg";
import Jun06_5 from "../Assets/06June-5.jpeg";
import ParkinsonWalkthon2 from "../Assets/ParkinsonWalkthon-2.jpeg";
import ParkinsonWalkthon3 from "../Assets/ParkinsonWalkthon-3.jpeg";
import ParkinsonWalkthon4 from "../Assets/ParkinsonWalkthon-4.jpeg";
import ParkinsonWalkthon5 from "../Assets/ParkinsonWalkthon-5.jpeg";
import ParkinsonWalkthon6 from "../Assets/ParkinsonWalkthon-6.jpeg";
import ParkinsonWalkthon7 from "../Assets/ParkinsonWalkthon-7.jpeg";
import Sep12Group from "../Assets/12Sep2026-Group.jpeg";
import Sep12Rohit from "../Assets/12Sep2026-Rohit.jpeg";
import Sep12Sushant from "../Assets/12Sep2026-Sushant.jpeg";
import Sep12Sushant2 from "../Assets/12Sep2026-Sushant-2.jpeg";
import Sep12Nancy from "../Assets/12Sep2026-Nancy.jpeg";
import Sep12Ahan from "../Assets/12Sep2026-Ahan.jpeg";
import Sep26Group from "../Assets/26Sep2026-Group.jpeg";
import Sep26Sai2 from "../Assets/26Sep2026-Sai-2.jpeg";
import Sep26Rohit from "../Assets/26Sep2026-Rohit.jpeg";
import Sep26Katy from "../Assets/26Sep2026-Katy.jpeg";
import Sep26Sai from "../Assets/26Sep2026-Sai.jpeg";
import Sep26Raja from "../Assets/26Sep2026-Raja.jpeg";

const SeattlePhotos = [
  // ── October 17, 2026 ─────────────────────────────────────
  {
    img: Oct17Ahan1,
    alt: "Ahan playing table tennis - October 17, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Oct17Group,
    alt: "Group photo - October 17, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Oct17Raja1,
    alt: "Raja playing table tennis - October 17, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Oct17Katy1,
    alt: "Katy playing table tennis - October 17, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Oct17Rohit1,
    alt: "Rohit playing table tennis - October 17, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Oct17Rohit2,
    alt: "Rohit in action - October 17, 2026 Seattle Pacific Table Tennis Club session",
  },
  // ── October 16, 2026 (Sunrise Community) ──────────────────
  {
    img: SunriseAhan16Oct1,
    alt: "Ahan playing table tennis with Sunrise Senior Living resident - October 16, 2026",
  },
  {
    img: SunriseAhan16Oct2,
    alt: "Ahan playing table tennis with Sunrise Senior Living resident - October 16, 2026",
  },
  {
    img: SunriseAhan16Oct3,
    alt: "Ahan playing table tennis with Sunrise Senior Living resident - October 16, 2026",
  },
  // ── September 26, 2026 ──────────────────────────
  {
    img: Sep26Group,
    alt: "Group photo — Parkinson's Neuro-Wellness session, September 26, 2026, Seattle Pacific Table Tennis Club",
  },
  {
    img: Sep26Sai2,
    alt: "Sai coaching at the table — Parkinson's Neuro-Wellness session, September 26, 2026, SPTTC",
  },
  {
    img: Sep26Rohit,
    alt: "Rohit rallying with participant — Parkinson's Neuro-Wellness session, September 26, 2026, SPTTC",
  },
  {
    img: Sep26Katy,
    alt: "Katy coaching participant — Parkinson's Neuro-Wellness session, September 26, 2026, SPTTC",
  },
  {
    img: Sep26Sai,
    alt: "Sai playing doubles — Parkinson's Neuro-Wellness session, September 26, 2026, SPTTC",
  },
  {
    img: Sep26Raja,
    alt: "Raja coaching participant — Parkinson's Neuro-Wellness session, September 26, 2026, SPTTC",
  },
  // ── September 12, 2026 ──────────────────────────
  {
    img: Sep12Group,
    alt: "Group photo — Parkinson's Neuro-Wellness session, September 12, 2026, Seattle Pacific Table Tennis Club",
  },
  {
    img: Sep12Rohit,
    alt: "Rohit coaching a participant — Parkinson's Neuro-Wellness session, September 12, 2026, SPTTC",
  },
  {
    img: Sep12Sushant,
    alt: "Sushant playing at the table — Parkinson's Neuro-Wellness session, September 12, 2026, SPTTC",
  },
  {
    img: Sep12Sushant2,
    alt: "Sushant in action — Parkinson's Neuro-Wellness session, September 12, 2026, SPTTC",
  },
  {
    img: Sep12Nancy,
    alt: "Nancy playing table tennis — Parkinson's Neuro-Wellness session, September 12, 2026, SPTTC",
  },
  {
    img: Sep12Ahan,
    alt: "Ahan coaching a participant — Parkinson's Neuro-Wellness session, September 12, 2026, SPTTC",
  },
  // ── August 21, 2026 (Sunrise Community) ───────────────────
  {
    img: Sunrise21Aug1,
    alt: "Sai playing table tennis with Sunrise Senior Living resident - August 21, 2026",
  },
  {
    img: Sunrise21Aug2,
    alt: "Sai playing table tennis with Sunrise Senior Living resident - August 21, 2026",
  },
  {
    img: Sunrise21Aug3,
    alt: "Sai playing table tennis with Sunrise Senior Living residents - August 21, 2026",
  },
  {
    img: Sunrise21Aug4,
    alt: "Sai playing table tennis with Sunrise Senior Living resident - August 21, 2026",
  },
  // ── PPP Tournament, August 2026 ──────────────────────────
  {
    img: PPPGroup,
    alt: "Group photo — PPP Tournament August 2026, Seattle Pacific Table Tennis Club",
  },
  {
    img: PPPTrophies,
    alt: "Tournament trophies — PPP Tournament August 2026, Seattle Pacific Table Tennis Club",
  },
  {
    img: PPPSaiKevin,
    alt: "Sai and Kevin — PPP Tournament August 2026, Seattle Pacific Table Tennis Club",
  },
  {
    img: PPPKevin,
    alt: "Kevin with trophy — PPP Tournament August 2026, Seattle Pacific Table Tennis Club",
  },
  {
    img: PPPKatyAhan,
    alt: "Katy presenting trophy to Ahan — PPP Tournament August 2026, Seattle Pacific Table Tennis Club",
  },
  {
    img: PPPChuckAngel,
    alt: "Chuck and Angel — PPP Tournament August 2026, Seattle Pacific Table Tennis Club",
  },
  {
    img: PPPChuckKevin,
    alt: "Chuck and Kevin — PPP Tournament August 2026, Seattle Pacific Table Tennis Club",
  },
  {
    img: PPPChuckNancy,
    alt: "Chuck and Nancy — PPP Tournament August 2026, Seattle Pacific Table Tennis Club",
  },
  {
    img: PPPChuckJim,
    alt: "Chuck and Jim — PPP Tournament August 2026, Seattle Pacific Table Tennis Club",
  },
  {
    img: PPPDKevin,
    alt: "Match action — PPP Tournament August 2026, Seattle Pacific Table Tennis Club",
  },
  {
    img: PPPDKaty,
    alt: "Match action — PPP Tournament August 2026, Seattle Pacific Table Tennis Club",
  },
  // ── August 1, 2026 ───────────────────────────────────────
  {
    img: Aug01Srikar1,
    alt: "Srikar coaching a player's grip at the table - August 1, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Aug01Ahan2,
    alt: "Ahan playing table tennis - August 1, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Aug01Group1,
    alt: "Group photo - August 1, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Aug01Angel1,
    alt: "Angel rallying at the table - August 1, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Aug01Sai1,
    alt: "Sai coaching a player - August 1, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Aug01Ahan1,
    alt: "Ahan playing table tennis - August 1, 2026 Seattle Pacific Table Tennis Club session",
  },
  // ── July 22, 2026 ────────────────────────────────────────
  {
    img: Jul22_1,
    alt: "Players rallying at the table - July 22, 2026 Seattle Table Tennis session",
  },
  {
    img: Jul22_2,
    alt: "Player returning a serve - July 22, 2026 Seattle Table Tennis session",
  },
  {
    img: Jul22_3,
    alt: "Coaching a player's grip at the table - July 22, 2026 Seattle Table Tennis session",
  },
  {
    img: Jul22_4,
    alt: "Player in action - July 22, 2026 Seattle Table Tennis session",
  },
  {
    img: Jul22_5,
    alt: "Players rallying with residents watching - July 22, 2026 Seattle Table Tennis session",
  },
  {
    img: Jul22_6,
    alt: "Player serving the ball - July 22, 2026 Seattle Table Tennis session",
  },
  // ── July 18, 2026 ────────────────────────────────────────
  {
    img: Jul18Srikar3,
    alt: "Srikar rallying with a player - July 18, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Jul18Srikar2,
    alt: "Srikar coaching a player's grip - July 18, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Jul18Sai1,
    alt: "Sai playing table tennis - July 18, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Jul18Srikar1,
    alt: "Srikar playing table tennis - July 18, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Jul18Angel1,
    alt: "Angel playing doubles - July 18, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Jul18Group,
    alt: "Group photo - July 18, 2026 Seattle Pacific Table Tennis Club session",
  },
  // ── July 10, 2026 (Sunrise Community) ─────────────────────
  {
    img: Sunrise10July1,
    alt: "Sai playing table tennis with Sunrise Community resident - July 10, 2026",
  },
  {
    img: Sunrise10July2,
    alt: "Sai playing table tennis with Sunrise Community residents - July 10, 2026",
  },
  {
    img: Sunrise10July3,
    alt: "Sai playing table tennis with Sunrise Community resident - July 10, 2026",
  },
  {
    img: Sunrise10July4,
    alt: "Sai playing table tennis with Sunrise Community resident - July 10, 2026",
  },
  {
    img: Sunrise10July5,
    alt: "Sai playing table tennis with Sunrise Community resident - July 10, 2026",
  },
  {
    img: Sunrise10July6,
    alt: "Sai playing table tennis with Sunrise Community resident - July 10, 2026",
  },
  {
    img: Sunrise10July7,
    alt: "Sai playing table tennis with Sunrise Community residents - July 10, 2026",
  },
  // ── June 27, 2026 ────────────────────────────────────────
  {
    img: Jun27Group,
    alt: "Group photo - June 27, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Jun27Ahan1,
    alt: "Ahan coaching at the table - June 27, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Jun27Rohit,
    alt: "Rohit playing - June 27, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Jun27Ahan2,
    alt: "Ahan in action - June 27, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Jun27Raja,
    alt: "Raja playing - June 27, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Jun27Ahan3,
    alt: "Ahan rallying - June 27, 2026 Seattle Pacific Table Tennis Club session",
  },
  // ── June 6, 2026 ─────────────────────────────────────────
  {
    img: Jun06Group,
    alt: "Group photo - June 6, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Jun06_1,
    alt: "Players in action - June 6, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Jun06_5,
    alt: "Doubles play - June 6, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Jun06_2,
    alt: "Match in progress - June 6, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Jun06_3,
    alt: "Youth player on court - June 6, 2026 Seattle Pacific Table Tennis Club session",
  },
  {
    img: Jun06_4,
    alt: "Player in action - June 6, 2026 Seattle Pacific Table Tennis Club session",
  },
  // ── Walk for Parkinson's 2026 ────────────────────────────
  {
    img: ParkinsonWalkthon2,
    alt: "Walk for Parkinson's 2026 — Participants gathering at the event.",
  },
  {
    img: ParkinsonWalkthon3,
    alt: "Walk for Parkinson's 2026 — Volunteers at the Table Tennis for Parkinson's Wellness booth.",
  },
  {
    img: ParkinsonWalkthon4,
    alt: "Walk for Parkinson's 2026 — Participants making their way to the track.",
  },
  {
    img: ParkinsonWalkthon5,
    alt: "Walk for Parkinson's 2026 — Team photo at the Northwest Parkinson's Foundation banner.",
  },
  {
    img: ParkinsonWalkthon6,
    alt: "Walk for Parkinson's 2026 — Walkers on the track at Husky Stadium.",
  },
  {
    img: ParkinsonWalkthon7,
    alt: "Walk for Parkinson's 2026 — Sai at the Table Tennis for Parkinson's Wellness booth.",
  },
  // ── May 23, 2026 ─────────────────────────────────────────
  {
    img: May23Group,
    alt: "Group photo - May 23, 2026 Seattle Parkinson's Table Tennis session",
  },
  {
    img: May23_1,
    alt: "Session in action - May 23, 2026 Seattle Parkinson's Table Tennis",
  },
  {
    img: May23_2,
    alt: "Players at the table - May 23, 2026 Seattle Parkinson's Table Tennis",
  },
  {
    img: May23_3,
    alt: "Participant smiling - May 23, 2026 Seattle Parkinson's Table Tennis",
  },
  {
    img: May23_4,
    alt: "Play in progress - May 23, 2026 Seattle Parkinson's Table Tennis",
  },
  {
    img: May23_5,
    alt: "Doubles play - May 23, 2026 Seattle Parkinson's Table Tennis",
  },
  // ── May 9, 2026 ──────────────────────────────────────────
  {
    img: May09Group,
    alt: "Group Photo - May 9, 2026 Seattle Table Tennis",
  },
  {
    img: May09Group2,
    alt: "Group doubles play - May 9, 2026 Seattle Table Tennis",
  },
  {
    img: May09Raja,
    alt: "Raja playing - May 9, 2026 Seattle Table Tennis",
  },
  {
    img: May09Ahan,
    alt: "Ahan playing - May 9, 2026 Seattle Table Tennis",
  },
  {
    img: May09Angel,
    alt: "Angel playing - May 9, 2026 Seattle Table Tennis",
  },
  {
    img: May09Ahan2,
    alt: "Ahan in action - May 9, 2026 Seattle Table Tennis",
  },
  // ── Apr 25, 2026 ─────────────────────────────────────────
  {
    img: Apr25Group,
    alt: "Group Photo - Apr 25, 2026 Seattle Table Tennis",
  },
  {
    img: Apr25JimSai,
    alt: "Jim and Sai - Apr 25, 2026 Seattle Table Tennis",
  },
  {
    img: Apr25Joe,
    alt: "Joe - Apr 25, 2026 Seattle Table Tennis",
  },
  {
    img: Apr25JoeRaja,
    alt: "Joe and Raja - Apr 25, 2026 Seattle Table Tennis",
  },
  {
    img: Apr25KaiMingAhan1,
    alt: "Kai Ming and Ahan - Apr 25, 2026 Seattle Table Tennis",
  },
  {
    img: Apr25KaiMingAhan2,
    alt: "Kai Ming and Ahan playing - Apr 25, 2026 Seattle Table Tennis",
  },
  {
    img: Apr25KaiMingAhan3,
    alt: "Kai Ming and Ahan in action - Apr 25, 2026 Seattle Table Tennis",
  },
  // ── Earlier sessions ─────────────────────────────────────
  {
    img: ParkinsonGroup2025_1,
    alt: "Parkinson Group 2025",
  },
  {
    img: ParkinsonAngel2025,
    alt: "Parkinson Angel 2025",
  },
  {
    img: SaiWithKids2026,
    alt: "Sai With Kids Feb 2026",
  },
  {
    img: SaiWithParkisonsPatients21Mar26,
    alt: "Sai with Parkison's Patients Playing 21 Mar 2026.",
  },
  {
    img: SaiWithParkisonsPatients07Mar26,
    alt: "Sai with Parkison's Patients Team.",
  },
  {
    img: WAHighSchoolTeam2026,
    alt: "WA High School Team 2026",
  },
  {
    img: SaiCoachingKidFeb2026,
    alt: "Sai Coaching Kid Feb 2026",
  },
  {
    img: SaiSchoolTTClub,
    alt: "Sai School TT Club",
  },
  {
    img: GroupParkisonsPatients04Apr2026,
    alt: "Group of Parkison's Patients Playing 04 Apr 2026.",
  },
  {
    img: WAStateParksinsons2025_2,
    alt: "Group of Parkison's Patients Playing 2025.",
  },
  {
    img: USNationals2026OutReach,
    alt: "US Nationals 2026 OutReach",
  },
  {
    img: WAStateParksinsons2025_3,
    alt: "Group of Parkison's Patients Playing 2025.",
  },
  {
    img: WAStateParksinsons2025_4,
    alt: "Group of Parkison's Patients Playing 2025.",
  },
  {
    img: WAStateParksinsons2025_5,
    alt: "Group of Parkison's Patients Playing 2025.",
  },
  {
    img: SaiWithPP1,
    alt: "Sai with Parkison's Patients Playing.",
  },
  {
    img: GroupParkisonsPatients21Mar26,
    alt: "Group of Parkison's Patients Playing 21 Mar 2026.",
  },
  {
    img: tt2025_1,
    alt: "Table Tennis Summer Camp 2025",
  },
  {
    img: SaiSrikar,
    alt: "Table Tennis Summer Camp 2025. Sai and Srikar",
  },
  {
    img: SaiSreyas,
    alt: "Table Tennis Summer Camp 2025. Sai and Sreyas",
  },
];

export default SeattlePhotos;